<template>
	<div class="head">
		<div class="centBlock">
			<div class="navList">
				<span @click="navDown(0)">首页<span v-if="$store.state.topNavIndex == 0" class="navLine"></span></span>
				<span @click="navDown(1)">解决方案<span v-if="$store.state.topNavIndex == 1" class="navLine"></span></span>
				<span @click="navDown(2)">核心技术<span v-if="$store.state.topNavIndex == 2" class="navLine"></span></span>
				<span @click="navDown(3)">关于机器人<span v-if="$store.state.topNavIndex == 3" class="navLine"></span></span>
			</div>
			<span class="headBtn" @click="$open.open">立即咨询</span>
		</div>
	</div>
</template>
<script>
  export default {
      data () {
	      return {

	      }
      },
      watch: {
	      $route (to, from) {
              if (to.path == '/') {
                  this.$store.state.topNavIndex = 0;
	          }
              if (to.path == '/programme') {
	              this.$store.state.topNavIndex = 1;
              }
              if (to.path == '/technology') {
	              this.$store.state.topNavIndex = 2;
              }
              if (to.path == '/robot') {
	              this.$store.state.topNavIndex = 3;
              }
	      }
      },
      methods: {
	      navDown(num){
	          this.$store.state.topNavIndex = num;
	          if(num == 0){
	              this.$router.push({
                      path: '/'
	              })
	          }
              if(num == 1){
                  this.$router.push({
	                  path: '/programme'
                  })
              }
              if(num == 2){
	              this.$router.push({
		              path: '/technology'
	              })
              }
              if(num == 3){
                  this.$router.push({
	                  path: '/robot'
                  })
              }
	      }
      },
      mounted () {

      }
  }
</script>
<style scoped>
	.head{
		width: 100%;
		padding: 60px 0;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 5;
	}
	.centBlock{
		height: 35px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.navList{
		display: flex;
		color: #fff;
		font-size: 16px;
		line-height: 22px;
	}
	.navList>span{
		margin-right: 40px;
		cursor: pointer;
		position: relative;
	}
	.navList>span:last-child{
		margin-right: 0;
	}
	.navLine{
		width: 20px;
		height: 4px;
		background: #fff;
		position: absolute;
		left: 50%;
		margin-left: -10px;
		bottom: -12px;
	}
	.headBtn{
		width: 120px;
		height: 35px;
		background: #FFFFFF;
		border-radius: 20px;
		font-size: 16px;
		line-height: 22px;
		color: #242E3A;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue